export default function SpecCard({

    title,

    icon,

    children

}) {

    return (

        <div className="specCard">

            <div className="specHeader">

                <span className="specIcon">
                    {icon}
                </span>

                <h3>{title}</h3>

            </div>

            <div className="specBody">

                {children}

            </div>

        </div>

    );

}